export enum MaskPlaceholder {
  DATE = 'DD.MM.YYYY',
  PHONE = '05X-XXX-XXXX',
}
